export const status = {
  WAITING: 'WAITING',
  OVERDUE: 'OVERDUE',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
  ALL: 'ALL',
}

export const statusText = {
  WAITING: 'รอเก็บเงิน',
  OVERDUE: 'เลยกำหนดการชำระเงิน',
  PAID: 'ชำระเงินแล้ว',
  CANCELLED: 'ยกเลิก',
  ALL: 'ทั้งหมด',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}

export const bankList = [
  {
    code: '000',
    text: 'เงินสด',
  }, {
    code: '001',
    text: 'ธนาคาร กรุงเทพฯ',
  }, {
    code: '002',
    text: 'ธนาคาร กรุงไทย',
  }, {
    code: '003',
    text: 'ธนาคาร กสิกรไทย',
  }, {
    code: '004',
    text: 'ธนาคาร ไทยพานิชย์',
  }, {
    code: '005',
    text: 'ธนาคาร นครหลวงไทย',
  }, {
    code: '006',
    text: 'ธนาคาร กรุงศรีอยุธยา',
  }, {
    code: '007',
    text: 'ธนาคาร ศรีนคร',
  }, {
    code: '008',
    text: 'ธนาคาร นครธน',
  }, {
    code: '009',
    text: 'ธนาคาร ทหารไทย',
  }, {
    code: '010',
    text: 'ธนาคาร ซากุระ',
  }, {
    code: '011',
    text: 'ธนาคาร โตเกียว',
  }, {
    code: '012',
    text: 'ธนาคาร มหานคร',
  }, {
    code: '013',
    text: 'ธนาคาร เอเชีย',
  }, {
    code: '014',
    text: 'ธนาคาร ไทยธนาคาร',
  }, {
    code: '015',
    text: 'ธนาคาร Standard Chartered',
  }, {
    code: '016',
    text: 'ธนาคาร ภารตโอเวอร์ซีส์',
  }, {
    code: '017',
    text: 'ธนาคาร ยูไนเต็ด โอเวอร์ซีส์ (ไทย) UOB',
  }, {
    code: '018',
    text: 'ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย',
  }, {
    code: '019',
    text: null,
  }, {
    code: '020',
    text: 'ธนาคาร รัตนสิน',
  }, {
    code: '021',
    text: 'ธนาคาร ซิตี้ แบงค์',
  }, {
    code: '022',
    text: 'ธนาคาร ยู โอ บี รัตรสิน',
  }, {
    code: '023',
    text: 'ธนาคาร ซูมิโตโม',
  }, {
    code: '024',
    text: 'ธนาคาร ฮ่องกง',
  }, {
    code: '025',
    text: null,
  }, {
    code: '026',
    text: null,
  }, {
    code: '027',
    text: null,
  }, {
    code: '028',
    text: null,
  }, {
    code: '029',
    text: null,
  }, {
    code: '030',
    text: null,
  }, {
    code: '031',
    text: 'ธนาคาร ซีโอเอ็มบี ไทย จำกัด',
  }, {
    code: '032',
    text: 'ธนาคารดอยซ์แบงก์',
  }, {
    code: '033',
    text: 'ธนาคารธนชาต',
  }, {
    code: '034',
    text: 'ธนาคารแลนด์ แอนด์ เฮ้าส์',
  }, {
    code: '901',
    text: null,
  }, {
    code: '902',
    text: 'โอนผ่าน ธนาคารไทยพาณิชย์',
  }, {
    code: '924',
    text: 'โอนผ่าน ธนาคาร ฮ่องกง',
  }, {
    code: '999',
    text: 'โอนผ่าน ธนาคาร',
  },
]
